'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import ErrorBoundary from '@/components/ErrorBoundary';
import TrustpilotWidget from '@/components/TrustpilotWidget';

function SectionSkeleton() {
  return (
    <div
      className="w-full py-24 md:py-32"
      aria-hidden="true"
      style={{
        background: 'linear-gradient(90deg, #111111 25%, #1a1a1a 50%, #111111 75%)',
        backgroundSize: '200% 100%',
        animation: 'shimmer 1.5s infinite linear',
        minHeight: '200px',
      }}
    />
  );
}

const ProcessSection = dynamic(() => import('./ProcessSection'), {
  ssr: true,
  loading: () => <SectionSkeleton />,
});

const ServicesSection = dynamic(() => import('./ServicesSection'), {
  ssr: true,
  loading: () => <SectionSkeleton />,
});

const TestimonialsSection = dynamic(() => import('./TestimonialsSection'), {
  ssr: false,
  loading: () => <SectionSkeleton />,
});

const BrandMarquee = dynamic(() => import('./BrandMarquee'), {
  ssr: false,
  loading: () => <SectionSkeleton />,
});

const CtaSection = dynamic(() => import('./CtaSection'), {
  ssr: false,
  loading: () => <SectionSkeleton />,
});

const ScrollAnimations = dynamic(() => import('./ScrollAnimations'), {
  ssr: false,
  loading: () => null,
});

function TrustpilotSection() {
  return (
    <section
      aria-label="Customer Reviews"
      style={{ background: '#121212', padding: '64px 24px' }}
    >
      <div className="max-w-8xl mx-auto">
        <h2
          className="font-fraunces font-bold text-white text-center mb-8"
          style={{ fontSize: 'clamp(1.6rem, 3vw, 2.4rem)' }}
        >
          What Our Customers Say
        </h2>
        {/* Carousel widget — shows real individual reviews */}
        <TrustpilotWidget templateId="53aa8912dec7e10d38f59f36" height="140px" />
        <div style={{ textAlign: 'center', marginTop: '16px' }}>
          <a
            href="https://uk.trustpilot.com/review/nolimitauto.co.uk"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#C00000', textDecoration: 'underline', fontSize: '1rem' }}
          >
            ⭐ See our 5-star reviews on Trustpilot ⭐
          </a>
        </div>
      </div>
    </section>
  );
}

export default function BelowFoldSections() {
  return (
    <>
      <ErrorBoundary>
        <ProcessSection />
      </ErrorBoundary>
      <ErrorBoundary>
        <ServicesSection />
      </ErrorBoundary>
      {/* Testimonials section temporarily hidden — restore when real customer reviews are ready */}
      {/* <ErrorBoundary>
        <TestimonialsSection />
      </ErrorBoundary> */}
      <ErrorBoundary>
        <TrustpilotSection />
      </ErrorBoundary>
      <ErrorBoundary>
        <BrandMarquee />
      </ErrorBoundary>
      <ErrorBoundary>
        <CtaSection />
      </ErrorBoundary>
      <ErrorBoundary>
        <ScrollAnimations />
      </ErrorBoundary>
    </>
  );
}
